import { Stack, Typography } from '@mui/material';
import type { FC } from 'react';

export const XeroInvoiceDetailsEmptyState: FC = () => {
  return (
    <Stack
      direction="column"
      style={{
        backgroundColor: '#F5F6FA',
        borderRadius: 1,
      }}
      sx={{
        gap: "24px",
        padding: "12px 20px",
        mb: 1.5,
        mt: 1.5,
        alignItems: "flex-start"
      }}>
      <Typography
        sx={{
          lineHeight: "20px",
          fontSize: 14,
          color: "#7E8796"
        }}>
        Sync to Xero to see invoice details
      </Typography>
    </Stack>
  );
};
